import { defineComponent, ref, inject, computed, watch, onMounted } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "OptionH5",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true,
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const optionRef = ref();
    const TSelect = inject("TSelect");
    const isActive = computed(() => {
      return TSelect && TSelect.label.value === props.label;
    });
    watch(
      () => props.label,
      (newValue) => {
        TSelect.addOption({
          label: props.label,
          value: props.value,
          ref: optionRef
        });
      }
    );
    onMounted(() => {
      TSelect.addOption({ label: props.label, value: props.value, ref: optionRef });
    });
    const handleOptionClick = () => {
      if (props.disabled) return;
      TSelect.handleOptionClick(props.value);
    };
    return { __sfc: true, optionRef, TSelect, props, isActive, handleOptionClick };
  }
});
export {
  _sfc_main as default
};
